import { CHAIN_ID } from '@derivation-tech/context';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { KlineData, KlineInterval } from '@synfutures/sdks-perp-datasource';
import { fetchFuturesPairKlineChart } from '../futures/api';

export const getPairKlineData = createAsyncThunk(
  'chart/getPairKlineData',
  async ({
    instrumentAddr,
    expiry,
    chartDuration,
    timeEnd,
    chainId,
  }: {
    chainId: CHAIN_ID;
    instrumentAddr: string;
    expiry: number;
    chartDuration: KlineInterval;
    timeEnd?: number;
  }): Promise<KlineData[] | null> => {
    return fetchFuturesPairKlineChart({
      chainId,
      instrumentAddress: instrumentAddr,
      expiry,
      klineInterval: chartDuration,
      timeEnd,
    });
  },
);
